import React, { useState } from 'react';

import TextInput from './TextInput';

type Props = {
  label: string;
  required?: boolean;
  placeholder?: string;
  autoComplete: 'new-password' | 'current-password';
  value: string;
  onChange: (value: string) => void;
  error?: string;
  name?: string;
};

function PasswordInput(props: Props) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <TextInput
      {...props}
      type={isVisible ? 'text' : 'password'}
      trailing={
        <button
          type="button"
          onClick={() => setIsVisible(!isVisible)}
          className="rounded-md p-2.5 text-retino-grey hover:text-retino-darkviolet focus:outline-none focus-visible:ring-2 focus-visible:ring-retino-darkviolet"
          aria-label={isVisible ? gettext('Hide password') : gettext('Show password')}
        >
          {isVisible ? (
            <svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M3 3l18 18" strokeLinecap="round" />
              <path
                d="M10.6 10.7a2 2 0 002.7 2.7M9.9 4.3A10.8 10.8 0 0112 4c5.5 0 9 5.5 9 8a8.8 8.8 0 01-2 3.3M6.6 6.6C4.3 8 3 10.3 3 12c0 2.5 3.5 8 9 8 1 0 2-.2 2.9-.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg className="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M3 12c0-2.5 3.5-8 9-8s9 5.5 9 8-3.5 8-9 8-9-5.5-9-8z" />
              <circle cx="12" cy="12" r="2.5" />
            </svg>
          )}
        </button>
      }
    />
  );
}

export default PasswordInput;
